import { render, staticRenderFns } from "./IncidentPerDcj.vue?vue&type=template&id=4743e888&"
import script from "./IncidentPerDcj.vue?vue&type=script&lang=ts&"
export * from "./IncidentPerDcj.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports